let PromiseWorker = require("promise-worker");

const notReady = "WASM module has not been instantiated";

class ModuleError extends Error {
  constructor(message, output) {
    super(message);
    this.name = this.constructor.name;
    this.output = output;
  }
}

const Module = {
  data: {
    ready: false
  },
  promiseWorker: null,
  methods: {
    init() {
      let worker = new Worker("/wasm/worker.js");
      Module.promiseWorker = new PromiseWorker(worker);

      Module.promiseWorker.postMessage({ ident: "main" }).then(() => {
        Module.data.ready = true;
      });
    },
    loadCase(casename) {
      if (!Module.data.ready) return Promise.reject(notReady);
      return Module.promiseWorker
        .postMessage({
          ident: "load_case",
          args: [casename]
        })
        .then(resp => {
          if (resp.err) throw new ModuleError(resp.err, resp.output);
          return resp;
        });
    },
    loadCaseData(data) {
      if (!Module.data.ready) return Promise.reject(notReady);
      let path = "/tmp/mpc.m";
      let message = { ident: "writeFile", args: [path, data] };
      return Module.promiseWorker
        .postMessage(message)
        .then(() => Module.methods.loadCase(path));
    },
    saveCase(mpc, name) {
      if (!Module.data.ready) return Promise.reject(notReady);
      let text = JSON.stringify(mpc);
      let message = { ident: "save_case", args: [text, name] };
      return Module.promiseWorker.postMessage(message).then(resp => {
        if (resp.err) throw new ModuleError(resp.err, resp.output);
        return resp;
      });
    },
    readRaw(data, rev) {
      if (!Module.data.ready) return Promise.reject(notReady);
      return Module.promiseWorker
        .postMessage({
          ident: "read_raw",
          args: [data, +rev]
        })
        .then(resp => {
          if (resp.err) throw new ModuleError(resp.err, resp.output);
          return resp;
        });
    },
    saveRaw(mpc) {
      if (!Module.data.ready) return Promise.reject(notReady);
      let text = JSON.stringify(mpc);
      let message = { ident: "save_raw", args: [text] };
      return Module.promiseWorker.postMessage(message).then(resp => {
        if (resp.err) throw new ModuleError(resp.err, resp.output);
        return resp;
      });
    },
    runPF(mpc, mpopt) {
      if (!Module.data.ready) return Promise.reject(notReady);
      let mpcData = JSON.stringify(mpc);
      let mpoptData = JSON.stringify(mpopt);
      return Module.promiseWorker
        .postMessage({
          ident: "runpf",
          args: [mpcData, mpoptData]
        })
        .then(resp => {
          if (resp.err) throw new ModuleError(resp.err, resp.output);
          return resp;
        });
    },
    runOPF(mpc, mpopt) {
      if (!Module.data.ready) return Promise.reject(notReady);
      let mpcData = JSON.stringify(mpc);
      let mpoptData = JSON.stringify(mpopt);
      return Module.promiseWorker
        .postMessage({
          ident: "runopf",
          args: [mpcData, mpoptData]
        })
        .then(resp => {
          if (resp.err) throw new ModuleError(resp.err, resp.output);
          return resp;
        });
    }
  }
};

export default Module;
